
import { handleHttpRequest, http, type HttpResponse } from 'interfaces'

export async function retirePersonFromPosition (orgId: number, positionId: number, personId: number): Promise<HttpResponse<[]>> {
  return await handleHttpRequest(http.post(`/api/v1/organizations/${orgId}/positions/${positionId}/employee/${personId}/retire/`))
}
